/* GENERADO — no editar a mano.
 *
 * Derivado de flow/src/components/shared/blocks/StoryCard/StoryCard.tsx quitandole los tipos, para
 * que la previsualizacion del back office editorial monte los MISMOS
 * componentes que renderiza /historias/[slug] en el sitio publico.
 *
 * Se regenera con:                 npm run historia:sync
 * Se verifica (falla si difiere):   npm run historia:diff
 *
 * Un cambio en el componente de flow se trae con `historia:sync`. Editar este
 * archivo directamente lo pierde en la siguiente regeneracion — y peor: hace
 * que la previsualizacion muestre algo distinto de lo que se publica, que es
 * justo lo que esa pantalla existe para evitar.
 *
 * La salida definitiva es publicar estos componentes en el Design System y que
 * los dos repos los consuman; ver
 * docs/superpowers/specs/2026-08-26-editorial-design-system-design.md §5.
 */
/* ░░ STORYCARD ░░ — port 1:1 del bloque StoryCard del Yool Design System
   (yool-design-system/project/components/blocks/StoryCard/StoryCard.tsx).
   Mismo DOM y tokens desde tokens.css. UNICA adaptacion sobre el original:
   `highlight`/`highlightColor`, para que la cita se resalte igual que en la
   portada (ver el comentario en la interfaz). */

import React from 'react';
import { renderHighlighted } from './highlight';
/* Compact photo story tile — used in grids of 3–4. Photo with a bottom dark
   gradient, a bold title (often a quote) and a caption. */
export const StoryCard = ({
  image,
  imagePosition = 'center',
  title,
  highlight,
  highlightColor = 'dark-cyan',
  subtitle,
  height = 300,
  onClick
}) => {
  const content = <>
      {image && <img src={image} alt="" aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: imagePosition
    }} />}
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(180deg, rgba(0,0,0,.02) 0%, rgba(0,0,0,.62) 100%)'
    }} />
      <div style={{
      position: 'absolute',
      left: 18,
      right: 18,
      bottom: 18,
      color: '#fff',
      textAlign: 'left'
    }}>
        <strong style={{
        display: 'block',
        font: '700 19px/1.15 var(--font-sans)',
        letterSpacing: '-0.02em'
      }}>
          {renderHighlighted(title, highlight, highlightColor)}
        </strong>
        {subtitle && <span style={{
        display: 'block',
        marginTop: 6,
        font: '400 13px/1.45 var(--font-sans)',
        color: 'rgba(255,255,255,.82)'
      }}>
            {subtitle}
          </span>}
      </div>
    </>;
  const base = {
    position: 'relative',
    minHeight: Number(height),
    overflow: 'hidden',
    borderRadius: 16,
    background: '#121212',
    boxShadow: 'var(--shadow-sm)'
  };
  if (onClick) {
    return <button type="button" onClick={onClick} style={{
      ...base,
      width: '100%',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'block'
    }}>
        {content}
      </button>;
  }
  return <div style={base}>{content}</div>;
};
export default StoryCard;
